import { useTranslation } from "react-i18next";
import { useContext, useState } from "react";
import IconButton from "mobily-ui-library/lib/components/composite/iconButton/IconButton";
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import Input from 'mobily-ui-library/lib/components/primitive/input/Input';

import { GlobalContext } from "../../context/GlobalContext";
import { getLeadOrderDetails, getCRNOrderDetails } from "../../api/apigeeApi";

import BackButton from "../../assets/BackButton.svg";
import ForwardButton from "../../assets/ForwardButton.svg";
import SelectCustom from "../Common/SelectCustom/SelectCustom";

export interface Props {
  rtl: boolean;
}

const win: any = window;
const sfaPhase = ['Credit Check', 'Rejected Credit Check', 'Accepted Credit Check', 'Lost'];
//const oppPhase = ['Reassigned to Sales', 'OMT Control', 'Order Completed', 'Order Creation', 'Finger Print'];
const oppPhase = [
  'Reassigned to Sales',
  'Verification/OMT',
  'Order Creation',
  'Order Completed',
  "WON",
  "Not Assigned",
  'Supply Chain Store',
  'Supply Chain Delivery',
  'Documentation Collection',
  'Finger Print',
  "Dropped",
  "Cancelled"
];

function CheckOrders({ rtl }: Props) {
  const [state, dispatch]: any = useContext(GlobalContext);
  const { t } = useTranslation();
  const options = [{ text: t("I_OrderNo"), value: t("I_OrderNo") }, { text: t("I_CRNo"), value: t("I_CRNo") }];
  const [selectValue, setSelectValue] = useState<string>(state.selectedValue === "" ? t("I_OrderNo") : state.selectedValue);
  const [orderNumber, setOrderNumber] = useState<string>("");
  const [crNumber, setCRNumber] = useState<string>(state.tractCrNum);
  const [mobileNumber, setMobileNumber] = useState<string>(state.trackMobileNum);
  const [orderError, setOrderError] = useState<string>("");
  const [crError, setCrError] = useState<string>("");

  const dir = rtl ? "right" : "left";
  const backButton = rtl ? ForwardButton : BackButton;

  const handleSelect = (value: any) => {
    setSelectValue(value);
    setOrderError("");
    setCrError("");
    setOrderNumber("");
    setCRNumber("");
    setMobileNumber("");
  };

  const statusPage = (values: any) => {
    dispatch({
      type: "TRACK_ORDER_NUMBER_DATA",
      // payload: { values, page: "Status" }
      payload: { values }
    });

    dispatch({ type: "LOADER", payload: { loading: false } });
  };

  const orderListPage = (values: any) => {
    const filterData = values.filter((item: any) => {
      return sfaPhase.includes(item.TUSER_STATUS_CODE) || (item.TUSER_STATUS_CODE === 'Converted' && oppPhase.includes(item.TDSC_SALPHASE))
    });
    if (filterData.length > 0) {
      dispatch({
        type: "TRACK_CRNUMBER_DATA",
        payload: { values: filterData, mobileNumber, crNumber, selectValue, page: t("Latest_order_status") },
      });
    } else {
      dispatch({ type: 'TRACKORDER_ERROR_PAGE', payload: { page: t("Trackorder_Error") } })
    }

    dispatch({ type: "LOADER", payload: { loading: false } });
  };

  const handleOrderChange = (e: any) => {
    const value = e.target.value;
    const pattern = /^[0-9a-zA-Z]{2,30}$/;
    const result = pattern.test(value);
    if (result) {
      setOrderError("");
      setOrderNumber(value);
    } else {
      if (value === '') {
        setOrderError(`${t("Please_Enter")} ${t("Order_Number")}`);
        setOrderNumber(value);
      } else {
        setOrderError(t("Verify_entered_info"));
        setOrderNumber(value);
      }
    }
  };

  const handleCRNChange = (e: any) => {
    const value = e.target.value;
    const pattern = /^[0-9a-zA-Z]{5,15}$/;
    const result = pattern.test(value);

    if (result) {
      setCrError("");
      setCRNumber(value);
    } else {
      if (value === '') {
        setCrError(`${t("Please_Enter")} ${t("CR_Number")}`);
        setCRNumber(value);
      } else {
        setCrError(t("Verify_entered_data"));
        setCRNumber(value);
      }
    }
  };

  const handleNext = () => {
    if (selectValue === options[0].text) {
      if (orderNumber === "") {
        setOrderError(`${t("Please_Enter")} ${t("Order_Number")}`);
      } else {
        if (orderError.length === 0) {
          dispatch({ type: "LOADER", payload: { loading: true } });
          getLeadOrderDetails(orderNumber)
            .then((res: any) => {
              if (res.status === 200 && res.data.StatusCode === '0000') {
                dispatch({ type: "LOADER", payload: { loading: false } });
                statusPage(res.data.d.results[0]);
                window.location = win['track_order_thanku_url']
              } else {
                dispatch({ type: "LOADER", payload: { loading: false } });
                dispatch({ type: 'TRACKORDER_ERROR_PAGE', payload: { page: t("Trackorder_Error") } })
              }
            });
        }
      }
    } else {
      if (crNumber === "") {
        setCrError(`${t("Please_Enter")} ${t("CR_Number")}`);
      } else {
        if (crError.length === 0) {
          dispatch({ type: "LOADER", payload: { loading: true } });
          getCRNOrderDetails(crNumber)
            .then((res: any) => {
              if (res.status === 200 && res.data.StatusCode === '0000') {
                dispatch({ type: "LOADER", payload: { loading: false } });
                orderListPage(res.data.d.results);
                window.location = win['track_order_thanku_url']

              } else {
                dispatch({ type: "LOADER", payload: { loading: false } });
                dispatch({ type: 'TRACKORDER_ERROR_PAGE', payload: { page: t("Trackorder_Error") } })
              }
            });
        }
      }
    }
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-sm-12 myOrders-container">
            <img
              src={backButton}
              onClick={() => (window.location = win["home_page_url"])}
              className={`myOrders-backButton group-${dir}`}
              alt="backbutton"
            />
            <div className={`myOrders-typography group-${dir}`}>
              <Typography className={`myOrders-title arabicBold-${dir} `} rtl={rtl}>
                {t("Track_my_order")}
              </Typography>
            </div>
            <div className={`myOrders-typography group-${dir}`}>
              <Typography className={`myOrders-subtitle arabicBoldMedium-${dir} `} rtl={rtl}>
                {t("OrderNo_CRNo_statement")}
              </Typography>
            </div>

            <div className={`myOrders-content group-${dir}`}>
              {/* <Select
                // @ts-ignore
                option={options}
                className="myOrders-select sansFont"
                width={"325px"}
                rtl={rtl}
                placeholder="Please Select"
                onChange={handleSelect}
                defaultValue={selectValue}
              /> */}
              <SelectCustom
                headingLeft={""}
                options={options}
                rtl={rtl}
                name="caCity"
                placeholder="Please Select"
                onChange={handleSelect}
                defaultValue={selectValue}
              />
              {selectValue === t("I_OrderNo") ? (
                <div
                  className={`myOrder-input ${orderError.length > 0 ? "error" : "normal"
                    }`}
                >
                  <Input
                    rtl={rtl}
                    headingleft={t("Order_Number")}
                    type={"inactive"}
                    width={325}
                    value={orderNumber}
                    maxLength={30}
                    onChange={handleOrderChange}
                    className="myOrders-input"
                  // errorIcon={orderError.length > 0 ? ErrorIcon : ""}
                  />
                  {orderError.length > 0 && (
                    <Typography className="otp-errorMsg" rtl={rtl}>
                      {orderError}
                    </Typography>
                  )}
                </div>
              ) : (
                <div
                  className={`myOrder-input ${crError.length > 0 ? "error" : "normal"
                    }`}
                >
                  <Input
                    rtl={rtl}
                    headingleft={t("CR_Number")}
                    type={"inactive"}
                    width={325}
                    value={crNumber}
                    maxLength={15}
                    onChange={handleCRNChange}
                    className="myOrders-input"
                  // errorIcon={crError.length > 0 ? ErrorIcon : ""}
                  />
                  {crError.length > 0 && (
                    <Typography className="otp-errorMsg" rtl={rtl}>
                      {crError}
                    </Typography>
                  )}
                </div>
              )}

              <div className={`myOrder-Button group-${dir}`}>
                <IconButton
                  width={"184px"}
                  height={"48px"}
                  onClick={handleNext}
                  rtl={rtl}
                >
                  {t("Next")}
                </IconButton>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CheckOrders;
